import React, { useState } from 'react';
import { TextField, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Headline from "./Headline";

interface EditableTitleProps {
    title_text: string
    onValueChangeSubmit(newValue?: string): void
}

const EditableTitle: React.FC<EditableTitleProps> = (props) => {
    const [isEditing, setIsEditing] = useState(false);
    const [name, setName] = useState(props.title_text);

    const handleSave = () => {
        props.onValueChangeSubmit(name)
        setIsEditing(false);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {isEditing ? (
                <TextField
                    variant="standard"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onBlur={handleSave}
                    autoFocus
                />
            ) : (
                <Headline title={name} size={"normal"}/>
            )}
            <IconButton onClick={() => setIsEditing(!isEditing)} size="small">
                {isEditing ? <SaveIcon /> : <EditIcon />}
            </IconButton>
        </div>
    );
};

export default EditableTitle;
